// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"e5c0c62d","253":"374d2080","434":"27162d2b","483":"a0070443","488":"c029449a","554":"384cfb0c","949":"20f6188d","983":"63d8516e"}[chunkId] + ".chunk.css";
};